<script setup>
import { getCurrentInstance } from 'vue';
import { RouterView } from 'vue-router';
const { ctx } = getCurrentInstance();


// 自适应
</script>
<template>
	<RouterView />
</template>
<style lang="scss">
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

nav {
	padding: 30px;

	a {
		font-weight: bold;
		color: #2c3e50;

		&.router-link-exact-active {
			color: #42b983;
		}
	}
}
</style>
